var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeaches(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u0421\\u043B\\u043E\\u0439_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 45 45",
    style: {
      enableBackground: "new 0 0 45 45"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#827F83;}\r\n\t.st1{fill:#827F83;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u0421\\u043B\\u043E\\u0439_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.3,37.2c0-0.9,0.7-1.6,1.6-1.6h29.3c0.9,0,1.6,0.7,1.6,1.6s-0.7,1.6-1.6,1.6H7.8C7,38.7,6.3,38,6.3,37.2z  M12.6,43.4c0-0.9,0.7-1.6,1.6-1.6h16.7c0.9,0,1.6,0.7,1.6,1.6S31.7,45,30.9,45H14.1C13.3,45,12.6,44.3,12.6,43.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M10.1,29.3c-1.1-2-1.7-4.3-1.7-6.8c0-7.8,6.3-14.1,14.1-14.1s14.1,6.3,14.1,14.1c0,2.5-0.6,4.8-1.7,6.8h8.5 c0.9,0,1.6,0.7,1.6,1.6s-0.7,1.6-1.6,1.6H1.6c-0.9,0-1.6-0.7-1.6-1.6s0.7-1.6,1.6-1.6H10.1L10.1,29.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.5,0c0.9,0,1.6,0.7,1.6,1.6v2.1c0,0.9-0.7,1.6-1.6,1.6s-1.6-0.7-1.6-1.6V1.6C20.9,0.7,21.6,0,22.5,0z  M6.6,6.6C7.2,6,8.2,6,8.8,6.6l0.8,0.8c0.6,0.6,0.6,1.6,0,2.2s-1.6,0.6-2.2,0L6.6,8.8C6,8.2,6,7.2,6.6,6.6z M38.4,6.6 c0.6,0.6,0.6,1.6,0,2.2l-0.8,0.8c-0.6,0.6-1.6,0.6-2.2,0s-0.6-1.6,0-2.2l0.8-0.8C36.8,6,37.8,6,38.4,6.6z M0,22.5 c0-0.9,0.7-1.6,1.6-1.6h2.1c0.9,0,1.6,0.7,1.6,1.6s-0.7,1.6-1.6,1.6H1.6C0.7,24.1,0,23.4,0,22.5z M39.8,22.5 c0-0.9,0.7-1.6,1.6-1.6h2.1c0.9,0,1.6,0.7,1.6,1.6s-0.7,1.6-1.6,1.6h-2.1C40.5,24.1,39.8,23.4,39.8,22.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeaches);
export default __webpack_public_path__ + "static/media/beaches.28a43dbe0359f74c1bdf9072f38fdcf8.svg";
export { ForwardRef as ReactComponent };